export const TALENYA_ROLE = 'TALENYA';
export const TALENT_EXPERT_ROLE = 'TE';
export const EMPLOYER_ROLE = 'EM';
export const EMPLOYER_RER_ADMIN_ROLE = 'EM_REP_ADMIN';
export const ACCAUNT_MANAGER_ROLE = 'AM';

export const UserRoles = {
    talenya: 'talenya',
    recruiter: 'recruiter',
    employer: 'employer',
    employerRep: 'employerRep',
    employerRepAdmin: 'employerRepAdmin',
};
